import React, { Component } from 'react';
import { AgGridReact } from "ag-grid-react";
import { Modal, message } from 'antd';
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import { httpClient } from '../../../../../net/httpClient';
import UrlConfig from '../../../../../net/UrlConfig';
import { localStorageClient } from '../../../../../utils/localStorageClient';


class HistoryUploadGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultColDef: {
                enableCellChangeFlash: true,
                minWidth: 50,
                sortable: true,
                filter: true,
                resizable: true,
            },
            context: { componentParent: this },
            columnDefs: [
                { field: 'attachmentType', headerName: 'attachmentType', width: 130, cellClass: 'non-number' },
                { field: 'representFileName', headerName: 'attachment', width: 300, cellClass: 'non-number', cellRenderer: this.downloadAttachmentCellRenderer },
                { field: 'uploadTime', headerName: 'uploadTime', width: 150, cellClass: 'non-number' },
                { field: 'uploadedBy', headerName: 'uploadedBy', width: 130, cellClass: 'non-number' },
                { field: 'uploadSource', headerName: 'uploadSource', width: 100, cellClass: 'non-number' },
                // { headerName: 'action', width: 100, cellClass: 'non-number', cellRenderer: this.removeAttachmentCellRenderer },
            ],
        };
    }

    removeAttachmentCellRenderer = (node) => {
        if (!node.data || node.data.attachmentType !== 'MonthlyStatement') {
            return '';
        }
        const button = document.createElement('button');
        button.innerText = 'Remove';
        button.className = 'ant-btn ant-btn-danger ant-btn-sm';
        button.onclick = () => this.removeMonthlyStatement(node.data);
        return button;
    }

    removeMonthlyStatement = (historyUpload) => {
        Modal.confirm({
            title: 'Remove this monthly statement?',
            content: 'This action cannot be undone.',
            onOk: () => httpClient.post(UrlConfig.REMOVE_MONTHLY_STATEMENT, { historyUploadId: historyUpload.id })
                .then(() => {
                    message.success('Monthly statement removed');
                    const { queryFields, baseDownloadUrl } = this.props.historyUpload.historyUploadDialogModal;
                    this.props.doHistoryUploadAction({ action: 'OPEN_AND_QUERY', queryFields, baseDownloadUrl });
                    if (this.props.loadPersonalAccount) {
                        const param = {
                            employee: localStorageClient.getUserName(),
                            approvalStatus: '',
                            needHoldingData: 'true',
                            source: 'Report',
                        };
                        this.props.loadPersonalAccount(param);
                    }
                })
                .catch((err) => {
                    message.error((err && err.respMessage) || 'Remove monthly statement failed');
                }),
        });
    }


    downloadAttachmentCellRenderer = (node) => {
        const {
            baseDownloadUrl,
        } = this.props.historyUpload.historyUploadDialogModal;

        const representFileName = node.data.representFileName;
        const realFileName = node.data.realFileName;
        if (!!representFileName && !!realFileName) {
            const url = baseDownloadUrl + '/' + realFileName;
            let link = document.createElement('a');
            link.innerText = representFileName;
            link.target = '_blank';
            link.href = url;
            return link;
        }
        return '';
    }

    render() {
        const {
            queryHistoryUploadStatus,
            queryHistoryUploadResp,
        } = this.props.historyUpload;

        const isLoading = queryHistoryUploadStatus === ACTION_STATUS.LOGINING;
        const historyUploadArray = !!queryHistoryUploadResp && !!queryHistoryUploadResp.data ? queryHistoryUploadResp.data : [];

        return (
            <div className={'ag-theme-balham grid-wrapper'}>
                {isLoading ? (
                    <Loader active content="Loading..." />
                ) : (
                    <AgGridReact
                        // properties
                        columnDefs={this.state.columnDefs}
                        rowData={historyUploadArray}
                        defaultColDef={this.state.defaultColDef}
                        suppressRowClickSelection={true}
                        suppressAggFuncInHeader={true}

                        animateRows={true}
                        deltaRowDataMode={false}
                        enableRangeSelection={true}
                        rowSelection={'single'}
                        getRowNodeId={this.getRowNodeId}
                        context={this.state.context}
                    />
                )}
            </div>
        );
    }

}


export default HistoryUploadGrid;
